import store from "@/store";
import _ from "underscore";

export function getEmptyUser() {
  return {
    email: null,
    mustChangePassword: false,
    requireAuthVerification: false,
    multiFactorAuthenticationMethod: null,
    prismsUserId: null,
    signInTime: null,
    userName: null,
  };
}

export function getEmptySignInDetails() {
  return {
    email: "",
    password: "",
    cookie: true
  };
}

export function getEmptyMfaChallengeAttempt() {
  return {
    verified: false,
    failedReason: "",
    maxAttemptsExceeded: false,
    validationError: ""
  }
}

export const dashboardHelper = {
  getDefaultWidgets,
  filterWidgets,
  availableWidgets,
  getWidgetName,
  getWidgetDescription
};

var Widgets = [
  {
    component: "WarningsAndFlagsWidget",
    name: "Provider warnings and flags",
    description: "Panel showing warnings and flags for providers in the levy collection."
  },
  {
    component: "ProviderStatusWidget",
    name: "Providers by status",
    description: "Chart showing counts (or total levies) of provider by status."
  },
  {
    component: "LevyComponentsWidget",
    name: "Levy components",
    description: "Doughnut chart showing the overall totals across all providers for each levy component."
  },
  {
    component: "NoticeCountsWidget",
    name: "Notice counts",
    description: "Chart showing notices that have been sent over the last 7 days."
  },
  {
    component: "PaymentStatusWidget",
    name: "Providers by payment status",
    description: "Chart showing counts (or total levies) of invoiced providers by their payment status."
  },
  {
    component: "InvoiceStatusWidget",
    name: "Invoices by status",
    description: "Chart showing counts (or total levies) of invoice by status."
  },
  {
    component: "ProviderLevyAmountsWidget",
    name: "Total levy amounts",
    description: "Bar chart showing the total levy amounts for all providers in the levy collection."
  },
  {
    component: "ActivityWidget",
    name: "Activity",
    description: "Chart showing activity against a levy collection during last 7 days or year."
  }
];

function getAllWidgets() {
  return _.pluck(Widgets, "component");
}

function getDefaultWidgets() {
  return _.filter(getAllWidgets(), val => {
    return (
      val == "WarningsAndFlagsWidget" ||
      val == "ProviderStatusWidget" ||
      val == "PaymentStatusWidget" ||
      val == "InvoiceStatusWidget" ||
      val == "NoticeCountsWidget" ||
      val == "LevyComponentsWidget" ||
      val == "ProviderLevyAmountsWidget" ||
      val == "ActivityWidget"
    );
  });
}

function filterWidgets(widgets, useDefault = false) {
  return _.filter(useDefault && !_.isArray(widgets) ? getDefaultWidgets() : widgets, item => {
    let claim = _.findWhere(Widgets, { component: item }).claim;
    return claim == undefined || store.getters.claims.includes(_.findWhere(Widgets, { component: item }).claim);
  });
}

function availableWidgets() {
  return filterWidgets(getAllWidgets());
}

function getWidgetName(widget) {
  return _.findWhere(Widgets, { component: widget }).name;
}

function getWidgetDescription(widget) {
  return _.findWhere(Widgets, { component: widget }).description;
}
